// eslint-disable-next-line import/no-anonymous-default-export
export default ["AGS-VIR-039", "AGS-VIR-019"];
